// extracted by mini-css-extract-plugin
module.exports = {"ctr":"page-frame-module--ctr--2LV6d","ctr1":"page-frame-module--ctr1--3J8KM","ctr2":"page-frame-module--ctr2--3Y9z3"};